import {
  TweenMax,
  TimelineMax,
  Power3,
} from 'gsap/TweenMax';
import store from '@/store';
import eventHub from '@/scripts/eventHub';
import ConfucioGroup from '@/scripts/stage/groups/ConfucioGroup';
import ComputerGroup from '@/scripts/stage/groups/ComputerGroup';
import PolaroidGroup from '@/scripts/stage/groups/PolaroidGroup';
import HamburgerGroup from '@/scripts/stage/groups/HamburgerGroup';
import CatGroup from '@/scripts/stage/groups/CatGroup';
import GhostGroup from '@/scripts/stage/groups/GhostGroup';
import RocketGroup from '@/scripts/stage/groups/RocketGroup';
import UfoGroup from '@/scripts/stage/groups/UfoGroup';
import BookGroup from '@/scripts/stage/groups/BookGroup';


export default class LoaderClass {
  constructor(ctx) {
    this.container = ctx;
    this.loaderYear = this.container.querySelector('.app__year');
    this.appYear = document.querySelector('.app__year');
    this.appYearSlider = document.querySelector('.app__slider-year');

    this.queue = {
      index: 0,
      els: 0,
    };
    this.loader = {
      progress: 0,
      progressPercent: 0,
      year: 0,
      end: () => store.state.route.name === 'home' ? 1990 : store.state.route.name === 'buyNow' ? 2019 : parseInt(store.state.route.params.year), // eslint-disable-line
      delta: 0,
    };

    this.clipVal = {
      left: 50,
      right: 50,
    };

    eventHub.$on('addFileToQueue', () => this.setQueue());

    this.setInitAnimation();
    this.timeline = this.loadingTimeline();
  }

  start() {
    const hadlerIncrement = () => this.incrementProgress();

    return Promise.all([
      ConfucioGroup.init(hadlerIncrement),
      ComputerGroup.init(hadlerIncrement),
      PolaroidGroup.init(hadlerIncrement),
      HamburgerGroup.init(hadlerIncrement),
      CatGroup.init(hadlerIncrement),
      GhostGroup.init(hadlerIncrement),
      RocketGroup.init(hadlerIncrement),
      UfoGroup.init(hadlerIncrement),
      BookGroup.init(hadlerIncrement),
    ]);
  }

  setQueue() {
    this.queue.els += 1;
    this.loader.delta = this.loader.end() / this.queue.els;
  }

  incrementProgress() {
    this.queue.index += 1;
    this.loader.progress = this.queue.index * this.loader.delta;
    this.loader.progressPercent = this.loader.progress / this.loader.end() * 100;

    this.animateProgress();
  }

  setInitAnimation() {
    TweenMax.set('.sidebar__container', { y: -120 });
    TweenMax.set('.app__sidebar-content', { autoAlpha: 0 }, 'start');
    TweenMax.set('.app__canvas', { autoAlpha: 0 });
  }

  animateProgress() {
    TweenMax.killTweensOf(this.timeline);
    TweenMax.to(this.timeline, 1.3, {
      progress: this.loader.progressPercent / 100,
      ease: Power3.easeInOut,
    });
  }

  loadingTimeline() {
    const tl = new TimelineMax({
      paused: true,
      onComplete: () => {
        store.commit('LOADING_DONE');
        eventHub.$emit('loadingEnd');
      },
    });

    tl.addLabel('start')
      .to(this.loader, 1, {
        year: `+=${this.loader.end()}`, // eslint-disable-line
        roundProps: 'year',
        onUpdate: () => {
          const zero = this.loader.year < 10 ? '000' : this.loader.year >= 10 && this.loader.year  < 100 ? '00' : this.loader.year >= 100 && this.loader.year < 1000 ? '0' : ''; // eslint-disable-line
          this.loaderYear.innerHTML = `${zero}${this.loader.year}`;
          this.appYearSlider.querySelector('.slider-year__item--initial').innerHTML = `${zero}${this.loader.year}`;
        },
      }, 'start');

    return tl;
  }
}
